// @flow

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import PayinList from 'PMT/entities/PayinList';
import PayoutList from 'PMT/entities/PayoutList';

class PaymentReceiptStore extends ReduceStore {

  getInitialState() {
    return {
      payoutList: null,
      payinList: null,

      /**
       * @type ApiError
       */
      apiError: null,
    }
  }

  getStateObjectsMap() {
    return {
      payoutList: new ApiError(),
      payinList: new PayinList(),
      apiError: new ApiError(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getPayoutList() {
    return this._state.payoutList;
  }

  getPayinList() {
    return this._state.payinList;
  }

  reduce(state, action, nextState) {
    switch(action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
      case ActionTypes.PAYMENT_PAYINS_RESPONSE_REQUEST:
      case ActionTypes.PAYMENT_PAYOUTS_RESPONSE_REQUEST:
        return this.getInitialState();

      case ActionTypes.PAYMENT_PAYINS_RESPONSE_SUCCESS:
        nextState.payinList = action.payinList;
        nextState.apiError = null;

        return nextState;

      case ActionTypes.PAYMENT_PAYOUTS_RESPONSE_SUCCESS:
        nextState.payoutList = action.payoutList;
        nextState.apiError = null;

        return nextState;

      default:
        return nextState;
    }
  }

}

export default new PaymentReceiptStore();
